import React, { Component } from 'react';
import classes from './Modal.module.css';
import Backdrop from '../Backdrop/Backdrop';
import Navbar from '../../Navigation/Navbar/Navbar';
import AppComponentContext from '../../../contexts/AppComponentContext';
import PropTypes from 'prop-types';
import { isFirefox, isChrome, isIOS, osVersion } from 'react-device-detect';

export default class Modal extends Component {
  render () {
    let navbar = null;
    if (this.props.navbarLeftElement !== null || this.props.navbarCenterElement !== null || this.props.navbarRightElement !== null) {
      navbar = (
        <div className={classes.Navbar} style={this.props.modalNavbarWrapperStyle}>
          <Navbar
            round
            left={this.props.navbarLeftElement}
            center={this.props.navbarCenterElement}
            right={this.props.navbarRightElement}
            fromModal
          />
        </div>
);
    }
    let ChildrenClass = isFirefox ? classes.ChildrenDifferent : isIOS && isChrome ? classes.ChildrenDifferent : classes.Children;
    let styleCss = {};
    if (isChrome && parseInt(osVersion, 10) >= 12) {
      styleCss.height = 'calc(100vh - 3.215rem)';
      styleCss.maxHeight = 'calc(100vh - 3.215rem)';
    }
    return (
      <AppComponentContext.Consumer>{appContext => (
        <div className={this.getWrapperClass(appContext)} style={styleCss}>
          {appContext.isLandscape ? <Backdrop clicked={this.props.modalClosed} /> : ''}
          <div className={this.props.checkout ? classes.ModalCheckout : classes.Modal} style={this.props.modalStyle}>
            {navbar}
            <div className={ChildrenClass} style={this.props.modalChildrenStyle}>
              {this.props.children}
            </div>
          </div>
        </div>
      )}
      </AppComponentContext.Consumer>
    );
  }

  getWrapperClass (appContext) {
    let wrapperClass;

    if (this.props.forceFixed) {
      wrapperClass = classes.ModalWrapperFixed;
    } else if (appContext.loggedIn) {
      wrapperClass = classes.ModalWrapper;
    } else {
      wrapperClass = appContext.isLandscape ? classes.ModalWrapperFixed : classes.ModalWrapperLandingPortrait;
    }
    return wrapperClass;
  }
}
Modal.propTypes = {
  forceFixed: PropTypes.bool
};
Modal.defaultProps = {
  navbarLeftElement: null,
  navbarCenterElement: null,
  navbarRightElement: null,
  modalWrapperStyle: {},
  modalStyle: {},
  modalNavbarWrapperStyle: {},
  modalChildrenStyle: {},
  forceFixed: false
};



// WEBPACK FOOTER //
// ./src/components/UI/Modal/Modal.js